import React from 'react';

import { useFiltro } from '../../../../../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import { DrawerHeaderButtonText } from './styles';

export const ClearButton = () => {
  const { clearFiltro } = useFiltro();

  const handleClearFilters = () => {
    clearFiltro();
  };

  return (
    <DrawerHeaderButtonText onClick={() => handleClearFilters()}>
      Limpar Filtros
    </DrawerHeaderButtonText>
  );
};
